import React, { useEffect } from 'react';
import type { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import {DeviceUUID} from 'device-uuid'
import {Alert, CssBaseline, makeStyles, Snackbar, ThemeProvider} from '@material-ui/core';
import './i18n';
import useScrollReset from './hooks/useScrollReset';
import routes from './routes';
import { createCustomTheme } from './theme';
import useSettings from "./hooks/useSettings";


const App: FC = () => {
  const content = useRoutes(routes);
  const { settings } = useSettings();
  useScrollReset();

  useEffect(() => {}, []);
  const useStyles = makeStyles((theme) => ({
    warning: {
      backgroundColor: 'yellow',
      fontWeight: 'bold',
      '& .MuiAlert-message': {
        color: 'black', // Cambia il colore del testo qui
      },
      '& .MuiSvgIcon-root': {
        fill: 'black', // Cambia il colore dell'icona qui
      },
    },
  }));
  const theme = createCustomTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme
  });
  const classes = useStyles();
  //setup uuid
  if(!localStorage.getItem("uuid")){
    const du = new DeviceUUID().parse();
    const dua = [
      du.language, du.platform, du.os, du.cpuCores, du.isAuthoritative, du.silkAccelerated, du.isKindleFire, du.isDesktop, du.isMobile,
      du.isTablet, du.isWindows, du.isLinux, du.isLinux64, du.isMac, du.isiPad, du.isiPhone, du.isiPod, du.isSmartTV,
      du.pixelDepth, du.isTouchScreen];
    localStorage.setItem("uuid",du.hashMD5(dua.join(':')))
  }
  return (
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <Toaster position="top-center" />
      {
        /*
         <Snackbar open={true} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert className={classes.warning} variant="filled" severity="warning">
          Gentile Utente, la Boa Limnologica del Lago d'Orta è momentaneamente offline per ordinaria manutenzione. Il servizio riprenderà il prima possibile. Ci scusiamo per il disagio
        </Alert>
      </Snackbar>
         */
      }
        {content}
    </ThemeProvider>
  );
};

export default App;
